export const selectOrganisationStructure = (state) =>
  state.meta.organisationStructure;
